<div *ngIf="!isRecuperarChaveAcesso" class="login-page">

    <div class="container app-container">


        <div *ngIf="clienteMensagem">
            <div *ngIf="!processando" class="alert alert-info col-xs-12 col-sm-8 col-sm-offset-2 " role="alert">
                <p>{{ clienteMensagem }}</p>
            </div>
        </div>

        <div *ngIf="processando" class="text-center" style="margin-top: 1em;">
            <i class="fa fa-spinner fa-pulse fa-4x"></i>
            <p>Carregando...</p>
        </div>

        <div *ngIf="hasLogo === false" class="col-xs-12 col-md-8">
            <div class="panel panel-warning">
                <div class="panel-heading">Atenção!</div>
                <div class="panel-body text-center">
                    <i class="fa fa-exclamation-triangle fa-3x"></i><br>
                    <p>
                        Serviço temporariamente indisponível!
                    </p>
                    <p>
                        Por favor, tente novamente em alguns minutos.
                    </p>
                    <p>
                        Agradecemos a compreensão!
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="navegadorInvalido" class="col-xs-12 col-md-8">
            <div class="panel panel-warning">
                <div class="panel-heading">Atenção!</div>
                <div class="panel-body text-center">
                    <i class="fa fa-exclamation-triangle fa-3x"></i><br>
                    <p>
                        Seu navegador é incompatível com nossa aplicação.
                    </p>
                    <p>
                        Para prosseguir com a utilização, recomendamos a instalação de um dos navegadores gratuitos
                        abaixo:
                    </p>
                    <p>
                        <a href="https://www.google.com/chrome/browser/desktop/">Google Chrome</a>,
                        <a href="https://www.mozilla.org/pt-BR/firefox/new/">Mozilla Firefox</a> ou
                        <a href="http://www.opera.com/pt-br">Opera</a>
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="hasLogo && !navegadorInvalido" class="loginbox-v2 col-xs-12">
            <div class="login-card">
                <h1>Premiado</h1>
                <hr>
                <div class="login-card-list-icons">
                    <img src="../../../assets/img/login/icon_loja.svg" alt="">
                    <img src="../../../assets/img/login/icon_serviços.svg" alt="">
                    <img src="../../../assets/img/login/Icon_contas.svg" alt="">
                </div>
            </div>
            <div class="text-left login-form">
                <div *ngIf="logotipo != undefined" class="app-logotipo-v2">
                    <img src="{{ logotipo }}" alt="Logotipo">
                </div>
                <form (ngSubmit)="doLogin($event)" ngNativeValidate>
                    <div *ngIf="!processando">
                        <div class="form-group">
                            <div class="input-group" style="width: 100%;">
                                <label>Chave de Acesso:</label>
                                <input id="chave-acesso" name="principal" type="text" class="form-control"
                                    [(ngModel)]="subject.principal" UiCartao>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group" style="width: 100%;">
                                <label>Senha:</label>
                                <input id="senha" name="password" type="password" [(ngModel)]="subject.password"
                                    class="form-control">
                            </div>
                        </div>
                        <div class="col-xs-12 text-center" style="padding: 0;">
                            <button id="entrar" class="btn app-btn-best-v2" type="submit" [disabled]="!botaoDisabled()"
                                style="width: 100%;">Entrar
                            </button>
                        </div>
                        <div class="col-xs-12 text-center login-form-links">
                            <br>
                            <span style="font-size: 0.95em;">
                                <a (click)="irParaRecuperarChaveDeAcesso()">Perdi minha chave de acesso.</a>
                            </span>
                            <br>
                            <span (click)="requestPwd()" id="makepwd" style="font-size: 0.95em;">
                                <a>Não tem senha ainda? Crie aqui.</a>
                            </span>
                        </div>


                        <!-- Botão de criar conta -->
                        <div *ngIf="possuiCadastroUsuario" class="col-xs-12 text-center">
                            <br>
                            <span style="font-size: 0.95em;">
                                <p style="margin: 0 0 4px">Ainda não esta cadastrado?</p>
                                <p><a (click)="router.navigate(['/novo-usuario'])" id="criarConta">Clique aqui para se
                                        cadastrar</a></p>
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</div>
<!-- <app-footer></app-footer> -->
<app-chave-de-acesso [logotipo]="logotipo" (isTelaDeLogin)="irParaLogin($event)" *ngIf="isRecuperarChaveAcesso">
</app-chave-de-acesso>

<app-footer></app-footer>


// WEBPACK FOOTER //
// ./src/app/public/login/login.component.html